import { render } from "./AtenObstForm.vue?vue&type=template&id=c32cddb2&scoped=true"
import script from "./AtenObstForm.vue?vue&type=script&lang=js"
export * from "./AtenObstForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=c32cddb2&scoped=true&lang=css"
import "@/assets/css/listaFiltrada.css?vue&type=style&index=1&id=c32cddb2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c32cddb2"]])

export default __exports__